import { useConfigContext } from "@/app";
import { useUserInfoStore } from "@/stores/userInfo";
import { Avatar, Button, SpinLoading, Toast, PullToRefresh } from "antd-mobile";
import { useCryptoMerchantInfoStore } from "../../../stores/CryptoMerchatStore";
import { useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import moduleStyles from './styles.module.scss';
import { RootHeader } from "@/components/RootHeader";
import { ContentTabs } from "../components/ContentTabs";
import styles from '../index.module.scss';
import { marginInrerest } from "@/apis/crypto";
import { actionBtns, transferBtns, level } from "./data";
import BalanceDetail from "./BalanceDetail";
import { cn } from "@/libs";
import { List } from "./List";
import { useMount } from "ahooks";
import { Icon } from "@/components/Icon";
import { UndoOutline } from "antd-mobile-icons";
import img_title from "@/assets/images/profession/title.png";
import img_go_profession from "@/assets/images/profession/go_profession.png";
import img_btn from "@/assets/images/profession/btn.png";
import img_text1 from "@/assets/images/profession/text1.png";
import img_text2 from "@/assets/images/profession/text2.png";
import img_user from "@/assets/images/profession/user.png";
import img_line from "@/assets/images/profession/line.png";
export const PageCryptoEarn = () => {
  const {
    getSourcePath,
    config
  } = useConfigContext();
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const cryptoMerchantInfo = useCryptoMerchantInfoStore(state => state.cryptoMerchantInfo);
  const getCryptoMerchantInfo = useCryptoMerchantInfoStore(state => state.getCryptoMerchantInfo);
  const [userinfo, getUserInfo] = useUserInfoStore()(state => [state.userInfo, state.updateUserInfo]);
  const listRef = useRef<any>();
  useMount(() => {
    getCryptoMerchantInfo();
  });
  const onClick = async (action: string) => {
    if (action === 'navigateToTransfer') {
      return navigate('/deposit_transfer/deposit_transfer_in');
    }
    if (action === 'interestSettlement') {
      const {
        ok,
        msg
      } = await marginInrerest();
      if (ok) {
        return Toast.show("领取成功");
      } else {
        return Toast.show(msg);
      }
    }
    if (action === 'transferin') {
      return navigate('/deposit_transfer/trans_in_balance_from_blockchain');
    }
    if (action === 'transferout') {
      return navigate('/deposit_transfer/merchant_balance_transout');
    }
    if (action === 'refresh' && !loading) {
      setLoading(true);
      try {
        await getCryptoMerchantInfo();
      } catch (e) {}
      return setLoading(false);
    }
    if (action === 'transfertoearn') {
      getUserInfo();
      getCryptoMerchantInfo();
      return navigate('/sell?m=1');
    }
  };
  const levelItem = useMemo(() => {
    return level[cryptoMerchantInfo.level?.matchingLevel || 'DEFAULT'];
  }, [cryptoMerchantInfo]);
  const reloadAsync = async () => {
    await getUserInfo();
    await getCryptoMerchantInfo();
    if (listRef.current) {
      listRef.current.childMethod();
    }
  };
  return <div className={styles.pageTrade} data-sentry-component="PageCryptoEarn" data-sentry-source-file="index.tsx">
        <RootHeader title={'赚钱'} data-sentry-element="RootHeader" data-sentry-source-file="index.tsx" />
        <ContentTabs active="crypto_earn" data-sentry-element="ContentTabs" data-sentry-source-file="index.tsx" />
        <PullToRefresh onRefresh={() => reloadAsync()} data-sentry-element="PullToRefresh" data-sentry-source-file="index.tsx">
            <div className={moduleStyles.header}>
                <div className={moduleStyles.header_avatar} onClick={() => navigate('/agreement_detail')}>
                    <div className={moduleStyles.header_avatar_image}>
                        <Avatar src={getSourcePath(userinfo.avatar)} data-sentry-element="Avatar" data-sentry-source-file="index.tsx" />
                        <div className={cn(moduleStyles.avatar_box, moduleStyles[levelItem.value])}></div>
                        <div className={moduleStyles.header_user_level}>{levelItem.text}</div>
                    </div>
                </div>
                <div className={moduleStyles.header_content}>
                    {actionBtns.map(btn => {
            return <div className={moduleStyles.header_item} key={btn.title}>
                                <span>{btn.icon}</span>
                                <span className={moduleStyles.header_item_title}>{btn.title}</span>
                                <span className={moduleStyles.amount}>{btn.amout(cryptoMerchantInfo)}</span>
                                <span className={moduleStyles.loading} onClick={() => onClick('refresh')}>{loading ? <SpinLoading style={{
                  '--size': '12px'
                }} /> : <UndoOutline />}</span>
                                {btn.action ? <Button onClick={() => {
                onClick(btn.action);
              }} size="small" className={moduleStyles.btn} style={{
                visibility: btn.action === 'refresh' ? 'hidden' : 'visible'
              }}>
                                        {btn.btn}
                                    </Button> : null}
                            </div>;
          })}
                </div>
            </div>
            

            {
      // 开启超级
      config?.ProfessionStatus === "1" ? <>
                        <div className={moduleStyles.mt}>
                            <BalanceDetail userInfo={cryptoMerchantInfo} />
                        </div>
                        <div className={moduleStyles.profession_box}>
                            <p className={moduleStyles.p_title}>
                                <img className={moduleStyles.revenue} src={img_title} alt="" />
                                <img className={moduleStyles.go_profession} src={img_go_profession} onClick={() => navigate('/profession_detail')} alt="" />
                            </p>
                            <img className={moduleStyles.line} src={img_line} alt="" />
                            <div className={moduleStyles.p_cont}>
                                <div>
                                    <img className={moduleStyles.img_text1} src={img_text1} alt="" />
                                    <img className={moduleStyles.img_text2} src={img_text2} alt="" />
                                </div>
                                <div className={moduleStyles.img_wrap}>
                                    <img className={moduleStyles.img_user} src={img_user} onClick={() => navigate('/sell?m=2')} alt="" />
                                    <img className={moduleStyles.img_btn} src={img_btn} onClick={() => navigate('/sell?m=2')} alt="" />
                                </div>
                            </div>
                        </div>
                    </> : null}
            
            <div className={moduleStyles.actions}>
            {transferBtns.map(btn => {
          return <Button onClick={() => {
            onClick(btn.action);
          }} key={btn.action} className={moduleStyles.action_btn}>{btn.title}</Button>;
        })}
            </div>
            <List ref={listRef} data-sentry-element="List" data-sentry-source-file="index.tsx" />
        </PullToRefresh>
        <div className={styles.whitespace}></div>
    </div>;
};